// 캐시 키 상수
export const CACHE_KEYS = {
  BANNER: 'banner-cache',
  BANNER_ETAG: 'banner-etag',
} as const;
